module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    staticClass: "main-header"
  }, [_c('nav', {
    staticClass: "navbar navbar-static-top",
    class: {
      'hidden-navbar': !_vm.showNavbar
    }
  }, [_c('img', {
    staticClass: "menu-ora",
    attrs: {
      "src": "/static/img/svg/menu.svg"
    },
    on: {
      "click": function($event) {
        return _vm.showSlider()
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "navbar-custom-menu"
  }, [(_vm.window.width > 400) ? _c('label', {
    staticClass: "fechaNav",
    staticStyle: {
      "text-transform": "capitalize"
    }
  }, [_vm._v(_vm._s(_vm._f("formatDate")(new Date(), 'dddd DD')))]) : _vm._e(), _vm._v(" "), (_vm.window.width > 400) ? _c('label', {
    staticClass: "fechaNav",
    staticStyle: {
      "padding-left": "5px",
      "padding-right": "5px"
    }
  }, [_vm._v("de")]) : _vm._e(), _vm._v(" "), (_vm.window.width > 400) ? _c('label', {
    staticClass: "fechaNav",
    staticStyle: {
      "text-transform": "capitalize"
    }
  }, [_vm._v(_vm._s(_vm._f("formatDate")(new Date(), 'MMM YYYY')))]) : _vm._e(), _vm._v(" "), _c('ul', {
    staticClass: "nav navbar-nav"
  }, [_c('li', {
    staticClass: "dropdown user user-menu dropdown-per"
  }, [_c('a', {
    staticClass: "dropdown-toggle nav-user-info",
    attrs: {
      "href": "#",
      "data-toggle": "dropdown"
    }
  }, [_c('img', {
    staticClass: "user-image img-color",
    attrs: {
      "src": "/static/img/svg/people.svg",
      "alt": "User Image"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "hidden-xs user-label"
  }, [_vm._v(_vm._s(_vm.userInfo.name.toLowerCase().trim()) + " ")])])])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-4356a822!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/navigation/NaviBarOrange.vue
// module id = 512
// module chunks = 1